import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
    components: {
        Header: () => import('@/components/header/index.vue'),
        leftBar: () => import('@/components/left-bar/index.vue'),
        Table: () => import('@/components/table/list/index.vue'),
        TableOptions: () => import('@/components/table/options/index.vue'),
    },
    data() {
        return {
            fields: [
                { key: 'id', label: 'ID' },
                { key: 'crm_status_title', label: 'Статус CRM' },
                { key: 'crm_status_color', label: 'Колір' },
            ],
            items: [],
            showAddForm: false,
            newStatusId: null,
            selectedItem: null,
            allCrmStatuses: [],
        };
    },
    computed: {
        ...mapGetters({
            menuHide: 'config/menuHide',
            ignoredStatuses: 'npAutomation/ignoredStatuses',
            crmStatuses: 'npAutomation/crmStatuses',
        }),
        availableStatuses() {
            const ignoredIds = this.items.map(i => i.crm_status_id);
            return this.allCrmStatuses.filter(s => !ignoredIds.includes(s.id));
        },
    },
    watch: {
        ignoredStatuses(data) {
            this.items = [];
            if (data && Array.isArray(data)) {
                data.forEach(item => {
                    this.items.push({
                        id: item.id,
                        crm_status_id: item.crm_status_id,
                        crm_status_title: item.crm_status?.title || '—',
                        crm_status_color: item.crm_status?.color || '',
                    });
                });
            }
        },
        crmStatuses(data) {
            this.allCrmStatuses = data || [];
        },
    },
    created() {
        this.toggleLoadingStatus(true);
        Promise.all([
            this.getIgnoredStatuses(),
            this.getCrmStatuses(),
        ]).then(() => {
            this.toggleLoadingStatus(false);
        });
    },
    methods: {
        selectItem(item) {
            this.selectedItem = item.length ? item : null;
        },
        addStatus() {
            if (this.newStatusId) {
                this.addIgnoredStatus({ crm_status_id: this.newStatusId }).then(res => {
                    if (res.status) {
                        this.getIgnoredStatuses();
                        this.$toasted.success('Статус додано до виключень', { duration: 3000 });
                        this.showAddForm = false;
                        this.newStatusId = null;
                    } else {
                        this.$toasted.error('Помилка додавання', { duration: 3000 });
                    }
                });
            }
        },
        removeItem(id) {
            this.removeIgnoredStatus(id).then(res => {
                if (res.status) {
                    this.getIgnoredStatuses();
                    this.$toasted.success('Статус видалено з виключень', { duration: 3000 });
                }
            });
        },
        ...mapActions({
            getIgnoredStatuses: 'npAutomation/getIgnoredStatuses',
            addIgnoredStatus: 'npAutomation/addIgnoredStatus',
            removeIgnoredStatus: 'npAutomation/removeIgnoredStatus',
            getCrmStatuses: 'npAutomation/getCrmStatuses',
        }),
        ...mapMutations({
            toggleLoadingStatus: 'config/toggleLoadingStatus',
        }),
    },
};

